<div class="attachments-panel">
  <div class="panel-title">{{ label }}</div>

  @if (hasContent) {
    <div class="attachments-scroll">
      @if (pendingFile) {
        <div class="attachments-row">
          <div class="file-name" [title]="pendingFile.name">
            {{ pendingFile.name }}
            <span class="pending-badge">Uploaded on save</span>
          </div>
          <div class="actions">
            @if (!readonlyAttachmentsPanel) {
              <button
                type="button"
                class="btn btn-outline-danger btn-icon"
                title="Remove file"
                (click)="confirmRemovePendingFile()">
                <i class="fa fa-solid fa-trash"></i>
              </button>
            }
          </div>
        </div>
      }

      @if (attachment) {
        <div class="attachments-row" [class.previous]="!!pendingFile">
          <div class="file-name" [title]="attachment.fileNameOriginal">
            {{ attachment.fileNameOriginal }}
            @if (pendingFile) {
              <span class="replaced-badge">Will be replaced</span>
            } @else {
              <span class="current-badge">Current</span>
            }
          </div>
          <div class="actions">
            <button
              type="button"
              class="btn btn-outline-secondary btn-icon"
              title="Download file"
              (click)="downloadFile(attachment)">
              <i class="fa fa-solid fa-download"></i>
            </button>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-text">{{ emptyText }}</div>
  }

  @if (canAddFile) {
    <div class="add-file">
      <input type="file" #fileInput [attr.accept]="accept || null" (change)="onFileSelected($event)" class="hidden-file-input" />
      <button type="button" class="btn btn-primary" (click)="fileInput.click()">
        @if (hasContent) {
          <i class="fa fa-solid fa-arrows-rotate me-1"></i> Replace file
        } @else {
          <i class="fa fa-solid fa-plus me-1"></i> Add file
        }
      </button>
    </div>
  }
</div>
